import { useEffect, useState } from "react";
import { getReferenceTable, getReferenceTables } from "../../api/reference";
import { ReferenceTable } from "../../types/interfaces/admin";
import { useErrorHandler } from "../Error/useErrorHandler";

export function useReferenceData(
  schema: string,
  table: string
) {
  const handleError = useErrorHandler();
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const tables: ReferenceTable[] = await getReferenceTables();

        const tableExists = tables.find(
          (t) => t.schemaName === schema && t.tableName === table
        );
        
        if (tableExists) {
          const tableData = await getReferenceTable(tables, schema, table, false)
          setData(tableData);
        }
      } catch (error) {
        handleError(error);
      }
    }

    fetchData();
  }, [schema, table]);

  return { data };
}